import "primevue/resources/themes/mdc-light-indigo/theme.css"
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

import Dropdown from "primevue/dropdown";
import InputMask from "primevue/inputmask";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import SplitButton from "primevue/splitbutton";
import Menubar from "primevue/menubar";
import RadioButton from "primevue/radiobutton";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Rating from "primevue/rating";
import Card from "primevue/card";
import Panel from "primevue/panel";
import ColorPicker from "primevue/colorpicker";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Carousel from "primevue/carousel";
import ProgressSpinner from "primevue/progressspinner";
import Checkbox from "primevue/checkbox";
import Sidebar from "primevue/sidebar";
import Toolbar from "primevue/toolbar";
import Dialog from "primevue/dialog";
import ToggleButton from "primevue/togglebutton";
import SelectButton from "primevue/selectbutton";
import Textarea from "primevue/textarea";
import TieredMenu from "primevue/tieredmenu";
import Galleria from "primevue/galleria";
import ConfirmationService from "primevue/confirmationservice";
export default [
  {
    name: "Dropdown",
    component: Dropdown
  },
  {
    name: "InputMask",
    component: InputMask
  },
  {
    name: "InputText",
    component: InputText
  },
  {
    name: "Button",
    component: Button
  },
  {
    name: "SplitButton",
    component: SplitButton
  },
  {
    name: "Menubar",
    component: Menubar
  },
  {
    name: "RadioButton",
    component: RadioButton
  },
  {
    name: "DataTable",
    component: DataTable
  },
  {
    name: "Column",
    component: Column
  },
  {
    name: "ColumnGroup",
    component: ColumnGroup
  },
  {
    name: "Rating",
    component: Rating
  },
  {
    name: "Card",
    component: Card
  },
  {
    name: "Panel",
    component: Panel
  },
  {
    name: "ColorPicker",
    component: ColorPicker
  },
  {
    name: "TabView",
    component: TabView
  },
  {
    name: "TabPanel",
    component: TabPanel
  },
  {
    name: "Carousel",
    component: Carousel
  },
  {
    name: "ProgressSpinner",
    component: ProgressSpinner
  },
  {
    name: "Checkbox",
    component: Checkbox
  },
  {
    name: "Sidebar",
    component: Sidebar
  },
  {
    name: "Toolbar",
    component: Toolbar
  },
  {
    name: "Dialog",
    component: Dialog
  },
  {
    name: "ToggleButton",
    component: ToggleButton
  },
  {
    name: "SelectButton",
    component: SelectButton
  },
  {
    name: "Textarea",
    component: Textarea
  },
  {
    name: "TieredMenu",
    component: TieredMenu
  },
  {
    name: "Galleria",
    component: Galleria
  },
  {
    name: "ConfirmationService",
    component: ConfirmationService
  }
];
